import { useMemo } from 'react'
import { useGetOrgImageQuery } from 'services/assets'

const useGetSignatureAndFingerprint = ({ fingerprintImageFileName = '', signatureImageFileName = '' }) => {
  const { data: signatureImageData } = useGetOrgImageQuery(
    {
      filename: signatureImageFileName,
      isTemp: false,
    },
    { skip: !signatureImageFileName },
  )

  const { data: fingerprintImageData } = useGetOrgImageQuery(
    {
      filename: fingerprintImageFileName,
      isTemp: false,
    },
    { skip: !fingerprintImageFileName },
  )

  const imagesAreReady = useMemo(() => {
    if (fingerprintImageFileName && signatureImageFileName) return fingerprintImageData && signatureImageData
    if (fingerprintImageFileName) return !!fingerprintImageData
    if (signatureImageFileName) return !!signatureImageData
    return true
  }, [fingerprintImageFileName, signatureImageFileName, fingerprintImageData, signatureImageData])

  return {
    signatureImageData,
    fingerprintImageData,
    imagesAreReady,
  }
}

export default useGetSignatureAndFingerprint
